export default __webpack_public_path__ + "static/media/product-08 (2).d617d658.jpg";